export const reports = {
	header: {
		revenue: "Facturación",
		service: "Servicio",
		products: "Productos",
		people: "Personas",
		ticket: "Ticket Promedio",
		entrance: "Cover/Entradas",
		day: "Día",
		period: "Período",
	},
	addPlacesTitle: "Agregar locales al informe",
	addPlacesPlaceholder: "Seleccione local(es)",
	all: "Todos",
	emptyComponent: "Sin datos para mostrar el informe",
	emptyPlaces: "Agregue al menos un local para mostrar el informe",
	tooltip: "No incluye cuentas abiertas",
	revenue: {
		title: "Facturación Total",
		paymentMethod: "Métodos de pago",
		periodChart: {
			perLocalTitle: "Facturación total por local",
			duringPeriodSubtitle: "Durante el período",
		},
		revenueChart: {
			entranceService: "Servicio de entrada: {{entrance}}",
		},
		methodChart: {
			rechargeDevolutions: "Recargas devueltas: {{value}}",
			adjustedMoney: "Efectivo ajustado: {{value}}",
		},
	},
	services: {
		title: "Servicio total",
		subtitle: "Por local en porcentaje",
	},
	products: {
		title: "Total de venta por horario",
		period: "Período: ({{since}} hasta {{until}})",
		dayFilter: "Seleccione el día",
		empty: "Sin datos para mostrar el informe",
		totalConsumedPeriod: "Total consumido de {{since}} hasta {{until}}:",
		totalConsumedAt: "Total consumido a las {{value}}",
		nextPeriod: "{{currPeriod}} hasta {{nextPeriod}}",
		currentPeriod: "a las {{currPeriod}}",
		periodTitle: "Período",
		productConsumptionTab: "Productos por hora",
		productsSold: {
			table: {
				count: "CANTIDAD",
				productName: "NOMBRE DEL PRODUCTO",
				place: "LOCAL",
				sku: "SKU",
				total: "Total",
				totalPlaceValue: "TOTAL DEL LOCAL",
				totalValue: "VALOR TOTAL",
				unitValue: "VALOR UNITARIO",
			},
			totalizers: {
				totalCount: "Cantidad total de productos",
				totalSold: "Facturación total del período",
			},
		},
		productSoldTab: "Productos vendidos por local",
	},
	downloadExcel: {
		title: "Informe {{orgName}}",
		fileName: "facturacion-{{orgName}}",
		columns: {
			date: "Fecha",
			place: "Local",
			service: "Servicio",
			inboundService: "Servicio de entrada",
			totalBilling: "Facturación total",
		},
	},
};
